import { render, staticRenderFns } from "./S3Uploads.vue?vue&type=template&id=098bd4b7&"
import script from "./S3Uploads.vue?vue&type=script&lang=js&"
export * from "./S3Uploads.vue?vue&type=script&lang=js&"
import style0 from "./S3Uploads.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./S3Uploads.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports